<template>
  <DatePicker
    @on-change="selectDate"
    :type="formate||'date'"
    :clearable='clearable'
    placeholder="选择日期"
    v-model="date"
  ></DatePicker>
</template>
<script>
export default {
  props: ["date1","formate","clearable"],
  data() {
    return {
      date: '',
    };
  },
  methods: {
    selectDate(v) {
      this.$emit("abc", this.utils.toSjc(this.date));
    },
  },
  mounted() {
    if (this.date1 != undefined) {
      this.date = new Date(this.date1);
    }
    this.$emit("abc", this.utils.toSjc(this.date));
  },
  model: {
    prop: "date1",
    event: "abc",
  },
  watch: {
    date1(v) {
      this.date = new Date(v);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/lyyymmdd.vue